"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BellIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const BellIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props),
    react_1.default.createElement("path", { d: "M6.30286 9.03031C6.30286 5.88396 8.85348 3.33334 11.9998 3.33334C15.1462 3.33334 17.6968 5.88396 17.6968 9.03031V19H6.30286V9.03031Z" }),
    react_1.default.createElement("path", { d: "M3.66649 19H8.33316V15H6.99983L3.2665 17.8C2.75396 18.1844 3.02582 19 3.66649 19Z" }),
    react_1.default.createElement("path", { d: "M20.3335 19H15.6668V15H17.0002L20.7335 17.8C21.246 18.1844 20.9742 19 20.3335 19Z" }),
    react_1.default.createElement("path", { d: "M13.3332 3.33333C13.3332 4.06971 12.7362 4.66667 11.9998 4.66667C11.2634 4.66667 10.6665 4.06971 10.6665 3.33333C10.6665 2.59695 11.2634 2 11.9998 2C12.7362 2 13.3332 2.59695 13.3332 3.33333Z" }),
    react_1.default.createElement("path", { d: "M14 20C14 21.1046 13.1046 22 12 22C10.8954 22 9.99999 21.1046 9.99999 20C9.99999 20 10.8954 20 12 20C13.1046 20 14 20 14 20Z" })));
exports.BellIcon = BellIcon;
exports.default = exports.BellIcon;
